module.exports = {
  header_menu: {
      login: 'Login',
      register: 'Register',
      logout: 'Log out',
  },
  home:require("./home/homeEN")
}